import React from "react";

const PrivacyPolicy = () => {
  return (
    <section className="terms-condition" style={{ padding: "40px 0" }}>
      <div className="container">
        <p style={{ color: "#111111", fontSize: "16pt" }}>
          <strong>
            <span>Effective from: November 20, 2023</span>
          </strong>
        </p>
        <p>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            At SmartOffice, we are committed to upholding the privacy and
            security of information as a fundamental right, irrespective of your
            nationality and geographic location. When you are using our
            services, we believe that you are entrusting us to handle your
            personal information safely. That endows us with the commitment to
            maintain transparency in regards to our collecting, using and
            sharing that information.&nbsp;
          </span>
        </p>
        <p>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            This SmartOffice Privacy Statement (“Privacy Statement”) describes
            how we collect, use, disclose, transfer, and store your personal
            data for the activities described below, including when you visit
            SmartOffice website that links to this Privacy Statement
            (“Website”), when you attend our marketing and learning events both
            online and offline (“Events”), and for our business account
            management. This Privacy Statement describes your choices and rights
            related to your personal data. A reference to “SmartOffice,” “we,”
            “us,”or the “Company” is a reference to SmartOffice. SmartOffice is
            the controller for the personal data discussed in this Privacy
            Statement, except as noted in the “SmartOffice as a Service
            Provider” section below.
          </span>
        </p>
        <p>
          <strong>
            <span style={{ color: "#111111", fontSize: "14pt" }}>
              SmartOffice as a Service Provider
            </span>
          </strong>
        </p>
        <p>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            SmartOffice customers are organizations such as businesses, NGOs or
            government offices, who use our services to help them manage
            personnel, students, and applicants. SmartOffice processes personal
            data in these services only according to our customers’
            instructions. If you have questions about personal data you have
            entered into a SmartOffice service used by one of our customers, or
            want to exercise any of your rights regarding your personal data,
            our customer contract requires that we redirect your inquiry back to
            that SmartOffice customer.
          </span>
        </p>
        <p>
          <strong>
            <u>
              <span style={{ fontSize: "14pt" }}>Privacy Statement</span>
            </u>
          </strong>
        </p>
        <p>
          <strong>
            <span style={{ color: "#111111", fontSize: "12pt" }}>1.&nbsp;</span>
            <span style={{ color: "#111111", fontSize: "13pt" }}>
              Information we collect
            </span>
          </strong>
        </p>
        <p>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            At SmartOffice, we collect information to provide better services to
            our users. This allows us to deliver customized services like
            personalized advertising, which helps keep many of our services
            free, and analyze and understand how our services are used. As part
            of our ongoing efforts to ensure the best possible user experience,
            we may use this information to identify and fix problems with our
            services, and to improve the services we offer you.
          </span>
        </p>
        <p>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            We collect information in the following ways:
          </span>
        </p>
        <div style={{ paddingLeft: "20px" }}>
          <p>
            <strong>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                1.1 Information shared by you
              </span>
            </strong>
          </p>
          <p>
            <span style={{ color: "#111111", fontSize: "12pt" }}>
              Our services require you to sign up for a SmartOffice account.
              When you do, we’ll ask for personal information, including but not
              limited to:
            </span>
          </p>
          <ul>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Contact information (e.g., name, email address, phone number)
                </span>
              </p>
            </li>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Employment-related information (e.g., job title, department,
                  work history)
                </span>
              </p>
            </li>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Account credentials
                </span>
              </p>
            </li>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Demographic information
                </span>
              </p>
            </li>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Any other information you voluntarily provide
                </span>
              </p>
            </li>
          </ul>
          <p>
            <strong>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                1.2 Information we get from your use of our services
              </span>
            </strong>
          </p>
          <p>
            <span style={{ color: "#111111", fontSize: "12pt" }}>
              We collect data about how you interact with our services. This
              information helps us understand user behavior, enabling us to
              enhance the user experience and develop features that meet our
              users’ needs. Here’s what this entails:
            </span>
          </p>
          <ul>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <strong>
                  <span style={{ color: "#111111", fontSize: "12pt" }}>
                    Usage Information:&nbsp;
                  </span>
                </strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  We collect data about your interactions with our services,
                  such as features used, the settings you select, and the
                  buttons you click. This helps us understand which aspects of
                  our service are most valuable to our users.
                </span>
              </p>
            </li>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <strong>
                  <span style={{ color: "#111111", fontSize: "12pt" }}>
                    Device Information:
                  </span>
                </strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  &nbsp;We may collect specific information about the device you
                  use to access our services, such as the hardware model,
                  operating system, and version. This helps us optimize our
                  services for common devices and operating systems.
                </span>
              </p>
            </li>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <strong>
                  <span style={{ color: "#111111", fontSize: "12pt" }}>
                    Log Information:&nbsp;
                  </span>
                </strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  When you use our services, we automatically collect and store
                  certain information in server logs. This includes details of
                  how you used our service, IP address, and device event
                  information such as crashes, system activity, hardware
                  settings, browser type, browser language, the date and time of
                  your request and referral URL.
                </span>
              </p>
            </li>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <strong>
                  <span style={{ color: "#111111", fontSize: "12pt" }}>
                    Location Information:&nbsp;
                  </span>
                </strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  We may collect and process information about your geographical
                  location. We use various technologies to determine location,
                  including IP address, GPS, and other sensors that may provide
                  information on nearby devices, Wi-Fi access points, and cell
                  towers.
                </span>
              </p>
            </li>
          </ul>
          <p>
            <strong>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                1.3 Information from third parties
              </span>
            </strong>
          </p>
          <p>
            <span style={{ color: "#111111", fontSize: "12pt" }}>
              In addition to the information you provide and the data we collect
              from your use of our services, we may also obtain information
              about you from third parties. Here’s how we use this information:
            </span>
          </p>
          <ul>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <strong>
                  <span style={{ color: "#111111", fontSize: "12pt" }}>
                    Third-Party Verification Services:&nbsp;
                  </span>
                </strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  We may use third-party verification services to authenticate
                  the information you provide to us.&nbsp;
                </span>
              </p>
            </li>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <strong>
                  <span style={{ color: "#111111", fontSize: "12pt" }}>
                    Business Partners:&nbsp;
                  </span>
                </strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  We may receive information about you from our business
                  partners, such as joint marketing partners and resellers, who
                  help us in delivering our services.
                </span>
              </p>
            </li>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <strong>
                  <span style={{ color: "#111111", fontSize: "12pt" }}>
                    Service Providers:
                  </span>
                </strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  &nbsp;We may receive information from third-party service
                  providers that help us with the provision of our services,
                  such as payment processors, customer support providers, and
                  analytics providers.
                </span>
              </p>
            </li>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <strong>
                  <span style={{ color: "#111111", fontSize: "12pt" }}>
                    Publicly Available Sources:&nbsp;
                  </span>
                </strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  We may collect information about you that is publicly
                  available. For example, if you post a review about our
                  services on a public forum, we may collect and use this
                  information to improve our services and better understand user
                  feedback.
                </span>
              </p>
            </li>
            <li
              style={{
                listStyleType: "disc",
                color: "#111111",
                fontSize: "12pt",
              }}
            >
              <p>
                <strong>
                  <span style={{ color: "#111111", fontSize: "12pt" }}>
                    Social Media Platforms:&nbsp;
                  </span>
                </strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  If you choose to link, create, or log in to your SmartOffice
                  account with a social media service (e.g., LinkedIn, Facebook,
                  Twitter), the social media service may send us information
                  such as your registration and profile information from that
                  service. This information varies and is controlled by that
                  service or as authorized by you via your privacy settings at
                  that service.
                </span>
              </p>
            </li>
          </ul>
          <p>
            <span style={{ color: "#111111", fontSize: "12pt" }}>
              Please note that we respect all applicable laws and regulations in
              our use of third-party data. We also require that these third
              parties comply with relevant laws and regulations and have
              appropriate safeguards in place to protect any information we
              obtain.
            </span>
          </p>
          <p>
            <strong>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                1.4 Cookies and Similar Technologies
              </span>
            </strong>
          </p>
          <p>
            <span style={{ color: "#111111", fontSize: "12pt" }}>
              SmartOffice may use website tracking technologies to observe your
              activities, interactions, preferences, transactional information,
              and other computer and connection information (such as an IP
              address) relating to your use of our websites and services. We may
              also use log files, cookies, and similar technologies to collect
              information about the pages you view, links you click, and other
              actions you take when accessing our website or emails.
            </span>
          </p>
        </div>
        <p>
          <strong>
            <span style={{ color: "#111111", fontSize: "12pt" }}>
              2. How We Use Your Information
            </span>
          </strong>
        </p>
        <p>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            At SmartOffice, we use the information we collect from you in
            several ways:
          </span>
        </p>
        <ul>
          <li
            style={{
              listStyleType: "disc",
              color: "#111111",
              fontSize: "12pt",
            }}
          >
            <p>
              <strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Providing and Improving Our Services:&nbsp;
                </span>
              </strong>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                We use your information to provide the services you've
                requested, create and manage your account, execute transactions,
                respond to customer service requests, and monitor and improve
                our services. For example, we may use your information to
                understand which features of our SaaS services are most popular
                and useful to our users, and use this insight to guide our
                future development efforts.
              </span>
            </p>
          </li>
          <li
            style={{
              listStyleType: "disc",
              color: "#111111",
              fontSize: "12pt",
            }}
          >
            <p>
              <strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Personalizing Your Experience:&nbsp;
                </span>
              </strong>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                We use your information to personalize the SmartOffice
                experience for you. This could include presenting tailored
                content or recommendations that we believe will be of interest
                to you, based on the information we have about your usage
                patterns and preferences.
              </span>
            </p>
          </li>
          <li
            style={{
              listStyleType: "disc",
              color: "#111111",
              fontSize: "12pt",
            }}
          >
            <p>
              <strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Communicating with You:&nbsp;
                </span>
              </strong>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                We use your information to communicate with you about your
                account and our services. This could include responding to your
                inquiries, notifying you of any changes to our services, and
                sending you technical notices, updates, security alerts, and
                administrative messages. We may also send you marketing
                communications about products, services, offers, programs, and
                promotions of SmartOffice and our partners.
              </span>
            </p>
          </li>
          <li
            style={{
              listStyleType: "disc",
              color: "#111111",
              fontSize: "12pt",
            }}
          >
            <p>
              <strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Conducting Research and Analysis:&nbsp;
                </span>
              </strong>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                We use your information for research and analysis purposes. We
                may use third-party service providers to help us with our
                research and analysis, but we only allow them to use your
                information to perform these services on our behalf. Our
                research and analysis activities are designed to help us
                understand our users, improve our services, and develop new
                features and services.
              </span>
            </p>
          </li>
          <li
            style={{
              listStyleType: "disc",
              color: "#111111",
              fontSize: "12pt",
            }}
          >
            <p>
              <strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Complying with Legal Obligations:&nbsp;
                </span>
              </strong>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                We use your information to comply with legal obligations to
                which we are subject. This could include complying with legal
                process, responding to requests from public and government
                authorities, enforcing our terms and conditions, protecting our
                operations, and protecting our rights, privacy, safety, or
                property, and/or that of you or others.
              </span>
            </p>
          </li>
        </ul>
        <p>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            Please note that we may use your information for other purposes that
            are compatible with the purposes we have disclosed to you, and that
            are related to the services we provide.
          </span>
        </p>
        <p>
          <strong>
            <span style={{ color: "#111111", fontSize: "12pt" }}>
              3. How We Share Your Information
            </span>
          </strong>
        </p>
        <p>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            At SmartOffice, we value your privacy and only share your
            information under certain circumstances:
          </span>
        </p>
        <ul>
          <li
            style={{
              listStyleType: "disc",
              color: "#111111",
              fontSize: "12pt",
            }}
          >
            <p>
              <strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Third-Party Service Providers:&nbsp;
                </span>
              </strong>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                We may share your information with third-party service providers
                that perform services on our behalf. These services could
                include data analysis, payment processing, information
                technology and related infrastructure provision, customer
                service, email delivery, auditing, and other similar services.
                These third-party service providers are only allowed to use your
                information to the extent necessary to provide the requested
                services.
              </span>
            </p>
          </li>
          <li
            style={{
              listStyleType: "disc",
              color: "#111111",
              fontSize: "12pt",
            }}
          >
            <p>
              <strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Business Partners:&nbsp;
                </span>
              </strong>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                We may share your information with our business partners in the
                context of our joint marketing efforts or other joint ventures.
                This could include partners who offer products or services that
                complement our own, or partners with whom we collaborate on the
                development of new products or services.
              </span>
            </p>
          </li>
          <li
            style={{
              listStyleType: "disc",
              color: "#111111",
              fontSize: "12pt",
            }}
          >
            <p>
              <strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Affiliates:&nbsp;
                </span>
              </strong>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                We may share your information with our affiliates, which are
                companies under common ownership or control with SmartOffice.
                Our affiliates may use this information for their everyday
                business purposes.
              </span>
            </p>
          </li>
          <li
            style={{
              listStyleType: "disc",
              color: "#111111",
              fontSize: "12pt",
            }}
          >
            <p>
              <strong>
                <span style={{ color: "#111111", fontSize: "12pt" }}>
                  Legal Authorities:&nbsp;
                </span>
              </strong>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                We may disclose your information to legal authorities when
                required by law or in response to a legal process, such as a
                court order or subpoena. We may also disclose your information
                if we believe it’s necessary to prevent, investigate, or take
                action regarding illegal activities, suspected fraud, situations
                involving potential threats to the safety of any person, or as
                evidence in litigation in which SmartOffice is involved.
              </span>
            </p>
          </li>
        </ul>
        <p>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            Please note that we take care to allow your information to be
            accessed only by those who really need to in order to perform their
            tasks and duties, and to share with third parties who have a
            legitimate purpose for accessing it. We will never sell or rent your
            information.
          </span>
        </p>
        <p>
          <strong>
            <span style={{ color: "#111111", fontSize: "12pt" }}>
              4. Security
            </span>
          </strong>
        </p>
        <p>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            We implement reasonable security measures to protect your
            information from unauthorized access, disclosure, alteration, and
            destruction. However, no method of transmission over the internet or
            electronic storage is 100% secure. Therefore, we cannot guarantee
            its absolute security.
          </span>
        </p>
        <p>
          <strong>
            <span style={{ color: "#111111", fontSize: "12pt" }}>
              5. Your Choices
            </span>
          </strong>
        </p>
        <p>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            You have choices regarding the collection and use of your
            information. You can:
          </span>
        </p>
        <ul>
          <li
            style={{
              listStyleType: "disc",
              color: "#111111",
              fontSize: "12pt",
            }}
          >
            <p>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                Opt out of certain data collection:&nbsp;
              </span>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                : If you prefer that we do not collect certain types of
                information, you have the option to opt out. Please note that
                some types of data are necessary for us to provide you with our
                services, and if you choose to opt out, it may affect the
                quality of your experience.
              </span>
            </p>
          </li>
          <li
            style={{
              listStyleType: "disc",
              color: "#111111",
              fontSize: "12pt",
            }}
          >
            <p>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                Update or delete your account information:&nbsp;
              </span>
              <span style={{ color: "#111111", fontSize: "12pt" }}>
                : You can review, update, or delete the personal information
                associated with your account at any time. To do this, simply log
                in to your account, go to your account settings, and make the
                necessary changes. If you wish to delete your account entirely,
                you can do so in the account settings. Please note that deleting
                your account will result in the loss of all data and content
                associated with that account, and we may not be able to recover
                it.
              </span>
            </p>
          </li>
        </ul>
        <p>
          <strong>
            <span style={{ color: "#111111", fontSize: "12pt" }}>
              6. Changes to this Privacy Statement
            </span>
          </strong>
        </p>
        <p>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            SmartOffice reserves the right to modify this Privacy Statement at
            any time in accordance with this provision. If we make changes to
            this Privacy Statement, we will post the revised Privacy Statement
            on the SmartOffice platform and update the “Last Updated” date at
            the top of this Privacy Statement. We will also provide you with
            notice of the modification by email at least thirty&nbsp;
          </span>
          <span style={{ color: "#111111", fontSize: "12pt" }}>(30)&nbsp;</span>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            days before the date the changes become effective. If you disagree
            with the revised Privacy Statement, you may cancel your account. If
            you do not cancel your account before the revised Privacy Statement
            becomes effective, your continued access to or use of the
            SmartOffice platform will constitute acceptance of the revised
            Privacy Statement.
          </span>
        </p>
        <p>
          <strong>
            <span style={{ color: "#111111", fontSize: "12pt" }}>
              7. Consent
            </span>
          </strong>
        </p>
        <p>
          <span style={{ color: "#111111", fontSize: "12pt" }}>
            By choosing to visit or use SmartOffice website or any of its
            services, you consent to the terms of this Privacy Statement.
          </span>
        </p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
